import { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography } from '@mui/material'
import authRoutes from '../routes/auth.routes'

const RequestPasswordResetDialog = ({ open, onClose, setstatus, onSuccess }) => {
    const [rut, setRut] = useState('')
    const [loading, setLoading] = useState(false)

    const handleRutChange = (event) => {
        const inputValue = event.target.value
        const onlyRUTChars = inputValue.replace(/[^0-9kK]/g, '')

        let formattedRut = ''
        if (onlyRUTChars.length > 1) {
            formattedRut = onlyRUTChars.slice(0, -1) + '-' + onlyRUTChars.slice(-1).toUpperCase()
        } else {
            formattedRut = onlyRUTChars
        }
        setRut(formattedRut)
    }

    const handleSubmit = async () => {
        if (!rut) return

        setLoading(true)
        setstatus({
            status: 'loading',
            title: 'Procesando solicitud',
            message: 'Por favor espere...'
        })

        try {
            const response = await authRoutes.requestResetInternal(rut)
            const data = response.data

            if (data.status === 'PENDING') {
                setstatus({
                    status: 'completed',
                    severity: 'info',
                    title: 'Solicitud Pendiente',
                    message: data.message || 'Ya tiene una solicitud en curso. Un administrador la revisará pronto.'
                })
            } else if (data.status === 'RESOLVED') {
                setstatus({
                    status: 'completed',
                    severity: 'success',
                    title: 'Solicitud Resuelta',
                    message: 'Por favor, inicie sesión y cambie su contraseña de inmediato.'
                })
                if (onSuccess) {
                    onSuccess({ rut, tempPassword: data.tempPassword })
                }
            } else {
                setstatus({
                    status: 'completed',
                    severity: 'success',
                    title: 'Solicitud Enviada',
                    message: data.message || 'Un administrador ha sido notificado para restablecer su contraseña.'
                })
            }
            onClose()
        } catch (error) {
            console.error('Error requesting password reset:', error)
            setstatus({
                status: 'error',
                title: 'Error al enviar solicitud',
                message: error.response?.data?.message || 'No se pudo completar la operación. Verifique su RUT e intente nuevamente.'
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 700, color: 'brown' }}>Restablecer Contraseña</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
                        Ingrese su RUT para que un administrador pueda restablecer su contraseña de acceso.
                    </Typography>
                    <Typography variant="caption" sx={{ display: 'block', mb: 2, p: 1, bgcolor: '#fff3e0', color: '#e65100', borderRadius: 1, borderLeft: '4px solid #ff9800' }}>
                        <strong>Nota:</strong> Solo puede tener una solicitud activa a la vez. Si ya solicitó el cambio, por favor espere la respuesta de un ejecutivo o administrador.
                    </Typography>
                    <TextField
                        fullWidth
                        label="RUT (ej: 12345678-9)"
                        value={rut}
                        onChange={handleRutChange}
                        variant="outlined"
                        autoFocus
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button onClick={onClose} color="inherit">Cancelar</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={!rut || loading}
                    sx={{ borderRadius: 2 }}
                >
                    Enviar Solicitud
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RequestPasswordResetDialog
